import { css, CSSObject } from '@emotion/react'
import { colors } from '@opallabs/spectrum'

const postWidth = {
  desktopSingle: 662,
  mobileSingle: 375,
}

const postHeight = {
  desktopSingle: 800,
  mobileSingle: 590,
}

const renderDisplayLayout = {
  desktopSingle: {
    minHeight: postHeight.desktopSingle,
    width: postWidth.desktopSingle,
    flexDirection: 'column',
  },
  mobileSingle: {
    minHeight: postHeight.mobileSingle,
    width: postWidth.mobileSingle,
    flexDirection: 'column',
    position: 'relative',
  },
}

export const baseStyles = (display: 'desktopSingle' | 'mobileSingle') => ({
  backgroundColor: colors.white.base,
  borderRadius: 2,
  display: 'flex',
  fontFamily: 'Helvetica',
  ...(renderDisplayLayout as any)[display],
  '.kuiper-asset-base': {
    display: 'flex',
    overflow: 'hidden',
    '&.kuiper-placeholder': {
      backgroundColor: colors.n8.base,
    },
    '.kuiper-asset': {
      backgroundColor: colors.n8.base,
    },
  },
})

export const accountWrapper = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

export const accountDetailsWrapper = css({
  display: 'flex',
  alignItems: 'center',
})

export const accountAvatar: CSSObject = {
  borderRadius: 0,
}

export const accountInputsWrapper = css({
  alignSelf: 'center',
  margin: '8px 0 0 4px',
})

export const accountName: CSSObject = {
  fontWeight: 500,
  marginLeft: 4,
}

export const timestampStyleOverrides: CSSObject = {
  fontFamily: 'Helvetica',
  fontSize: 14,
  opacity: 0.6,
  paddingLeft: 2,
}
